import { FormRow } from "../../common/hook-form";
import { PriceInput } from "../../../components/forms/inputs/PriceInput";
import { SwitchInput } from "../../../components/forms/inputs/SwitchInput";
import { SelectCurrencyInput } from "../../../components/forms/inputs/SelectCurrencyInput";
import { CreateProductPayload, Product } from "../models/product";
import { useFormContext } from "react-hook-form";
import { TextInput } from "../../../components/forms/inputs/TextInput";
import { TextField } from "../../../components/forms/fields/TextField";
import { ProductVatNotice, VAT_RULE_RATE_LABEL } from "./ProductVatNotice";

type Props = {
  isEdit?: boolean;
  product?: Product;
};

export const ProductPricingForm = ({ isEdit, product }: Props) => {
  const methods = useFormContext<
    (CreateProductPayload | Product) & { files: File[] }
  >();
  const isPriceDifferentiationEnabled = methods.watch(
    "isPriceDifferentiationEnabled"
  );

  return (
    <>
      <FormRow>
        <PriceInput
          formMethods={methods}
          name="priceAmount"
          currencyName="priceCurrency"
        />
        <SelectCurrencyInput name="priceCurrency" />
      </FormRow>
      <SwitchInput
        label="If disabled, the product will have the same price for pick up and delivery. If enabled, you can differentiate the price of the product for pick up and delivery."
        name="isPriceDifferentiationEnabled"
      />
      {isPriceDifferentiationEnabled && (
        <FormRow>
          <PriceInput
            formMethods={methods}
            label="Delivery price"
            name="priceDeliveryAmount"
            currencyName="priceCurrency"
            helpertext="Price of the product, if delivery is chosen."
          />
        </FormRow>
      )}
      <ProductVatNotice product={product} />
      {product?.vatRuleId ? (
        <TextField
          type="number"
          label={VAT_RULE_RATE_LABEL}
          helperText="Serving can have a different rate, set by the same VAT rule."
          value={product.vat}
          disabled
        />
      ) : (
        <TextInput
          name="vat"
          placeholder="Enter VAT"
          type="number"
          label="VAT percentage"
          helperText="The VAT of the product."
        />
      )}
      {isEdit && (
        <TextInput
          name="priceDescription"
          placeholder="Enter price description"
          label="Product price description"
          helperText="Can be used to describe the price of the product. E.g. 'Lunch offer', 'Monday - sunday 100,00 DKK'. Will appear in red on the product in apps, kiosks and website."
        />
      )}
    </>
  );
};
